// extracted by mini-css-extract-plugin
export default {"italicText":"italicText__TGjag","buttonGroup":"buttonGroup__Daaxt","device-image-container":"device-image-container__96ayW"};